var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup28(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8115 5C15.0873 7.59265 15.5172 10.1185 15.6621 12.7261C15.7309 13.9653 15.8437 15.1909 15.9535 16.4199C16.0436 17.4291 16.215 18.4818 16.2495 19.4841C16.2679 20.0178 16.3341 20.5505 16.3341 21.0725C16.3341 22.4475 15.9958 23.7958 15.9958 25.1658C15.9958 27.7406 15.9112 30.4036 15.9112 33",
    stroke: "#1390E6",
    strokeWidth: 10.0186,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.7357C11.1699 19.4331 17.4797 19.2943 23.513 18.5107C25.3436 18.273 27.0083 17.793 28.7066 17.3808C29.4858 17.1916 30.1223 16.9694 30.943 16.83",
    stroke: "#1390E6",
    strokeWidth: 10.0186,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup28);
export default __webpack_public_path__ + "static/media/Group28.56193cb46f62dcef9a00925f0d480749.svg";
export { ForwardRef as ReactComponent };